<div class="relative p-6">
  <!-- Close Button -->
  <i
    type="button"
    data-bs-dismiss="modal"
    aria-label="Close"
    (click)="closeDialog()"
    class="color-4 fs-2 far fa-times-circle absolute top-[-10px] right-[-10px] m-3"
    #closebutton
  ></i>

  <div class="flex flex-col justify-center items-center w-full">
    <div class="w-[50%] flex flex-col items-center mt-4 space-y-4">
      <h2 for="contactSelect" class="f-poppins fw-500 txt_3 fs-15 mb-2">
        WhatsApp Info
      </h2>
      <div class="flex gap-2 items-center">
        <span class="w-[180px]"
          >Template Name <span class="required_sign">*</span></span
        >
        <!-- <form [formGroup]="fg" class="w-full">
          <mat-form-field appearance="outline" class="w-full">
            <input matInput formControlName="name" required  (input)="onNameInput()" autocomplete="off"/>
            <mat-error class="relative bottom-[3px]" *ngIf="fg.controls['name'].invalid && fg.controls['name'].touched">
              Name is required
            </mat-error>
          </mat-form-field>
        </form> -->
        <form [formGroup]="fg" class="w-full">
          <mat-form-field appearance="outline" class="w-full">
            <mat-select formControlName="name" placeholder="Select Template">
              @for (template of templateList; track template) {
                <mat-option [value]="template.name">
                  {{ template.name }}
                </mat-option>
              }
            </mat-select>

            @if (fg.controls['name'].invalid && fg.controls['name'].touched) {
              <mat-error class="relative bottom-[3px]">
                Name is required
              </mat-error>
            }
          </mat-form-field>
        </form>
      </div>
      <div class="flex gap-2 items-center">
        <span class="w-[180px]"
          >Select Number <span class="required_sign">*</span></span
        >
        <mat-form-field appearance="outline">
          <mat-select
            id="contactSelect"
            class="text-1 d-inline-block w-full"
            (selectionChange)="onSelectedOption($event.value)"
            [(value)]="selectedContact"
          >
            @for (obj of dialogData?.contact; track obj) {
              <mat-option [value]="obj">
                {{ obj.name }} {{ obj.mobile_number }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <!-- <div class="flex gap-2 items-center">
    <span class="w-[180px]">Select Language  <span class="required_sign">*</span></span>
    <mat-form-field appearance="outline" class="w-100">
      <mat-select [formControl]="languageCtrl">
        <mat-option disabled>
          <ngx-mat-select-search
            [formControl]="languageSearchCtrl"
            placeholderLabel="Search language..."
            noEntriesFoundLabel="No language found"
          ></ngx-mat-select-search>
        </mat-option>
    
        <mat-option *ngFor="let lang of filteredLanguages" [value]="lang.code">
          {{ lang.name }} ({{ lang.code }})
        </mat-option>
      </mat-select>
    </mat-form-field>    
  </div> -->
    </div>
  </div>

  <div class="text-3 fw-500 mt-4 rounded-3 d-flex justify-center space-x-4">
    <button
      #openReasons
      type="button"
      class="btn btn-p-2 btn-skyblue-s-1 primary-btn mx-2"
      data-bs-toggle="collapse"
      data-bs-target="#collapse-dealStage"
      aria-expanded="false"
      aria-controls="collapse-dealStage"
      (click)="closeDialog()"
    >
      {{ 'COMMON.Cancel' | translate }}
    </button>
    <button
      class="standard-btn btn btn-p-2 mx-2"
      type="submit"
      [disabled]="!isFormValid()"
      [ngClass]="{ disabled: !isFormValid() }"
      (click)="submit()"
    >
      {{ 'EMAILS.Send' | translate }}
    </button>
  </div>
</div>
